import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { SEND_FOR_APPROVAL, SEND_FOR_APPROVAL_ERROR, SEND_FOR_APPROVAL_SUCCESS } from '../../../actionType.js';
import cogoToast from 'cogo-toast';

function* sendForApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program/${payload?.params?.id}/${payload?.params?.section}`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SEND_FOR_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: SEND_FOR_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_FOR_APPROVAL_ERROR, payload: error });
  }
}

export function* watchSendForApproval() {
  yield takeEvery(SEND_FOR_APPROVAL, sendForApproval);
}

function* getSendForApprovalSaga() {
  yield all([fork(watchSendForApproval)]);
}

export default getSendForApprovalSaga;
